import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { Box, styled } from '@mui/material';

export const RequestDatesListItem = styled('div')({
  display: 'flex',
  flexDirection: 'column'
});

export const RequestDateWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginRight: '15px'
});

export const RequestDate = styled(Box)({
  fontWeight: 500
});

export const RequestDateStatus = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center'
});

export const RequestDateAvalableStatusIcon = styled(CheckCircleOutlineIcon)({
  color: '#008A06',
  width: '15px',
  height: '15px',
  marginRight: '5px'
});

export const RequestDateNotAvailableStatusIcon = styled(HighlightOffIcon)({
  color: '#E31B0C',
  width: '15px',
  height: '15px',
  marginRight: '5px'
});

export const RequestDateToolbar = styled(Box)({
  display: 'flex',
  justifyContent: 'end',
  margin: '2px 15px 0 0;'
});
